import { RequireCapability } from "@/components/RequireCapability";

import { AdminApp } from "./components/admin/AdminApp";
import { FinancialAidsArea } from "./components/FinancialAidsArea";
// Registers the slice's financialAids.* translations (side-effect import).
import "./i18n";

/**
 * Financial-aids directory area (route: /financial-aids). Reached contextually
 * from a piste d'action (the Aides financières icon on an action-plan action);
 * gated to any authenticated user.
 */
export function FinancialAidsPage() {
  return (
    <RequireCapability required={["authenticated"]}>
      <FinancialAidsArea />
    </RequireCapability>
  );
}

/**
 * The CQDD financial-aids back-office (route: /financial-aids/admin) — list,
 * create/edit, import. Admin-gated.
 */
export function FinancialAidsAdminPage() {
  return (
    <RequireCapability required={["expertAdmin"]}>
      <AdminApp />
    </RequireCapability>
  );
}
